"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import Image from "next/image";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const JobCarousel = () => {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const endpoint = `${process.env.NEXT_PUBLIC_API_URL}/jobs`;
        const res = await fetch(endpoint, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        const data = await res.json();
        if (res.ok && data?.data?.jobs) setJobs(data.data.jobs);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };
    fetchJobs();
  }, []);
  

  return (
    <Swiper
      className="swiper job-carousel rbt-arrow-between rbt-dot-bottom-center pb--20 icon-bg-primary"
      slidesPerView={1}
      spaceBetween={30}
      modules={[Navigation, Pagination]}
      pagination={{ el: ".rbt-swiper-pagination", clickable: true }}
      navigation={{ nextEl: ".rbt-arrow-right", prevEl: ".rbt-arrow-left" }}
      breakpoints={{
        481: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
      }}
    >
      {jobs.slice(0, 10).map((job, index) => {
        const jobId = job._id || index;
        const jobTitle = (job.jobTitle || "Untitled Job").toUpperCase();

        return (
          <SwiperSlide key={jobId} className="pb-4">
            <div className="rbt-card job-card variation-01 rbt-hover h-100 d-flex flex-column">
              {/* Image Section */}
              <div className="rbt-card-img flex-shrink-0">
                <Link href={`/job-detail/${jobId}`}>
                  <Image
                    src={job.logoUrl || "/images/others/job.jpg"}
                    width={350}
                    height={400}
                    alt={job.jobTitle}
                    className="w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </Link>
              </div>

              {/* Card Body */}
              <div className="rbt-card-body flex-grow-1 d-flex flex-column p-3">
                <h5
                  className="rbt-card-title mb-2"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    minHeight: "48px",
                  }}
                >
                  <Link href={`/job-detail/${jobId}`}>{jobTitle}</Link>
                </h5>

                <p
                  className="rbt-card-text mb-3"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    lineHeight: "1.5",
                    minHeight: "66px",
                  }}
                >
                  {job.jobDescription || "Job description not available."}
                </p>

                {/* Footer Fixed at Bottom */}
                <div className="mt-auto pt-3 border-top">
                  <Link className="rbt-btn-link" href={`/job-detail/${jobId}`}>
                    View details <i className="feather-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </SwiperSlide>
        );
      })}

      {/* Swiper Arrows */}
      <div className="rbt-swiper-arrow rbt-arrow-left">
        <div className="custom-overfolow">
          <i className="rbt-icon feather-arrow-left"></i>
          <i className="rbt-icon-top feather-arrow-left"></i>
        </div>
      </div>
      <div className="rbt-swiper-arrow rbt-arrow-right">
        <div className="custom-overfolow">
          <i className="rbt-icon feather-arrow-right"></i>
          <i className="rbt-icon-top feather-arrow-right"></i>
        </div>
      </div>

      <div className="rbt-swiper-pagination" style={{ bottom: "0" }}></div>
    </Swiper>
  );
};

export default JobCarousel;

